import React from "react";
import { Radio } from "antd";
import PropTypes from "prop-types";

import { ButtonChartTooltipsTypes } from "./ButtonChartTooltipsTypes";
import { IconLight } from "../icon_light";

const ButtonChartTooltips = ({ selectedValue, onClick }) => {
  function onChange(event) {
    onClick(event.target.value);
  }

  return (
    <Radio.Group
      onChange={onChange}
      defaultValue={selectedValue}
      className={"test-button-chart-tooltips"}
    >
      <Radio.Button value={ButtonChartTooltipsTypes.Single}>
        <span title={"Single tooltip mode in chart view"}>
          <IconLight icon={"code-commit"} />
        </span>
      </Radio.Button>
      <Radio.Button value={ButtonChartTooltipsTypes.Multiple}>
        <span title={"Multiple tooltip mode in chart view"}>
          <IconLight icon={"list-ul"} flip={"horizontal"} />
        </span>
      </Radio.Button>
    </Radio.Group>
  );
};

ButtonChartTooltips.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ButtonChartTooltips;



// WEBPACK FOOTER //
// ./src/views/components/button_chart_tooltips/ButtonChartTooltips.jsx